export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20atmosphere%20with%20soft%20ambient%20lighting%2C%20elegant%20home%20theater%20setting%20with%20comfortable%20seating%2C%20warm%20golden%20and%20amber%20tones%2C%20cozy%20modern%20interior%2C%20subtle%20film%20grain%20texture%2C%20atmospheric%20movie%20night%20vibe%2C%20soft%20bokeh%20lights%2C%20cinematic%20color%20grading%2C%20premium%20aesthetic&width=1600&height=900&seq=hero-banner-99&orientation=landscape"
        alt="久久视频 - 海量高清视频"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          海量高清视频
          <span className="block text-accent-400">一站畅享</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
          热门影视、综艺节目、动漫番剧、原创短视频，久久视频汇聚全网精彩内容，免费高清在线观看
        </p>

        <div className="relative max-w-lg mx-auto">
          <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
          <input
            type="text"
            placeholder="搜索你喜欢的视频..."
            className="w-full pl-12 pr-24 py-3.5 text-base rounded-full bg-white/95 border-0 focus:outline-none focus:ring-2 focus:ring-primary-400 text-foreground-800 placeholder:text-foreground-400 transition-all"
          />
          <button className="absolute right-1.5 top-1/2 -translate-y-1/2 px-5 py-2 text-sm font-medium rounded-full bg-primary-500 hover:bg-primary-600 text-white transition-colors whitespace-nowrap cursor-pointer">
            搜 索
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 mt-6">
          {['电影', '电视剧', '综艺', '动漫', '纪录片'].map((tag) => (
            <span
              key={tag}
              className="px-3 py-1.5 text-xs font-medium rounded-full bg-white/15 text-white border border-white/20 hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-5 h-8 rounded-full border-2 border-white/40 flex items-start justify-center p-1">
          <div className="w-1 h-2 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}